import React from 'react';
import { EXPERIENCE } from '../../data/portfolio';

const Experience: React.FC = () => (
  <div className="page">
    <header>
      <h2>
        experience <span>{EXPERIENCE.length} roles</span>
      </h2>
      <p>Internships and academic roles: what shipped and what moved.</p>
    </header>
    <div className="tl">
      {EXPERIENCE.map((job) => (
        <article key={job.id} className="tl-item">
          <div className="tl-meta">
            <span className="tl-dates">{job.dates}</span>
            <span className="tl-type">{job.type}</span>
          </div>
          <div className="tl-body">
            <div className="tl-head">
              {job.logo && (
                <img className="tl-logo" src={job.logo} alt="" aria-hidden="true" />
              )}
              <div>
                <h3>{job.title}</h3>
                <p className="tl-org">
                  {job.org} · {job.location}
                </p>
              </div>
            </div>
            {job.metrics && job.metrics.length > 0 && (
              <div className="tl-metrics">
                {job.metrics.map(([v, k]) => (
                  <div key={k} className="tl-metric">
                    <div className="v">{v}</div>
                    <div className="k">{k}</div>
                  </div>
                ))}
              </div>
            )}
            <ul className="tl-bullets">
              {job.bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
            {job.tags && (
              <div className="tl-tags">
                {job.tags.map((t) => (
                  <span key={t}>{t}</span>
                ))}
              </div>
            )}
          </div>
        </article>
      ))}
    </div>
  </div>
);

export default Experience;
